"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _conditionalRendering = require("./conditionalRendering");
var _checkConditions = require("./checkConditions");
var _excluded = ["text"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var CustomDropdown = props => {
  //get a handle to the content fields
  var field = props.field,
    toggleId = field.valueField.id,
    toggleName = field.valueField.name,
    dropdownLabel = field.model.title,
    required = field.model.required,
    options = field.model.items,
    showEmptyItem = field.model.showEmptyItem,
    state = _conditionalRendering.store.getState(),
    conditionId = field.model.conditionSettings.fieldKey,
    fieldName = field.valueField.name;

  // setup for layout
  var css = props.field.model.cssClass;
  var labelCss = props.field.model.labelCssClass;
  var shouldHide,
    showRequired = "";

  // setup for error handling
  var errorMessages = [];
  if (props.errors.length > 0) {
    css = css + ' is-invalid';
  }

  // replace 'text' field name with 'label' as the field name to work with Blueprint
  // recreate array with only certatin fields otherwise console log from Blueprint because all properties are passed
  var data = options.map(_ref => {
    var {
        text
      } = _ref,
      options = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread(_objectSpread({}, options), {}, {
      label: text
    });
  });
  data = data.map(_ref2 => {
    var {
      label,
      value,
      selected
    } = _ref2;
    return {
      label,
      value,
      selected
    };
  });

  // get a handle to the 'label' of the pre-selected option
  var preSelectedLabel = data.reduce((acc, cur) => (cur.selected && acc.push(cur.label), acc), []).toString();
  var preSelectedValue = data.reduce((acc, cur) => (cur.selected && acc.push(cur.value), acc), []).toString();

  // setup for if the field is required
  if (required) {
    showRequired = "*";
  }

  // setup for adding empty list item to top of list
  if (showEmptyItem) {
    data.unshift("");
  }

  // Handle 'click' events on the Dropdown items.
  var onChange = e => {
    // setup for getting the 'label' based on the item selected
    var selectedValue = data.find(x => x.value === e);
    if (selectedValue === undefined) {
      //try making defaultlabel
      selectedValue = {
        label: dropdownLabel ? dropdownLabel + showRequired : '',
        value: ''
      };
    }
    var newLabel = selectedValue.label;
    var newValue = selectedValue.value;
    var fieldKey = field.model.conditionSettings.fieldKey;
    preSelectedValue = newValue;
    if (state !== undefined) {
      state.fieldValues[fieldKey] = newLabel;
    }
    var valid = true;
    if (field.model.required && !newValue) {
      valid = false;
      errorMessages.push(field.model.title !== '' ? field.model.title + ' is required' : 'field is required');
    }
    props.onChange(toggleName, newValue, valid, errorMessages);
  };
  if (state !== undefined) {
    if (state.conditions[conditionId] !== undefined) shouldHide = (0, _checkConditions.checkConditions)(state.fieldValues, state.conditions[conditionId]);
    var hideArray = state.hiddenFields;
    if (shouldHide) {
      if (hideArray.indexOf(fieldName) === -1) {
        hideArray.push(fieldName);
      }
    } else {
      if (hideArray.indexOf(fieldName) > -1) {
        hideArray = hideArray.filter(e => e !== fieldName);
      }
    }
    state.hiddenFields = hideArray;
  }
  if (shouldHide) {
    return null;
  } else {
    // options are within the form setup - static & dynamic values
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-spacing--minor"
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, dropdownLabel ? /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: toggleId,
      className: labelCss
    }, dropdownLabel + showRequired) : null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.DropdownSelect, {
      data: data,
      toggleId: toggleId,
      toggleName: toggleName,
      onSelect: onChange,
      className: css,
      required: required,
      defaultSearchValue: preSelectedLabel,
      defaultLabel: "Select One"
    }), /*#__PURE__*/_react.default.createElement(_Form.default.Control.Feedback, {
      type: "invalid"
    }, props.errors.map((error, index) => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, error.substring(0, 1) === ' ' ? 'field' + error : error);
    }))));
  }
};
var _default = exports.default = CustomDropdown;